import type { TranslationDict } from './ja'

export const ar: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'طريقة اللعب',
  helpAria: 'طريقة اللعب',
  settings: 'الإعدادات',
  settingsAria: 'الإعدادات',
  close: 'إغلاق',
  closeAria: 'إغلاق',
  player: 'اللاعب',
  highscore: 'أفضل نتيجة',
  start: 'ابدأ اللعب',
  staminaEmpty: 'الطاقة غير كافية',
  ranking: 'معركة الأراضي',
  difficultyTitle: 'اختر الصعوبة',
  difficultyStart: 'ابدأ بهذه الصعوبة',
  back: 'رجوع',
  today: 'اليوم',
  weekly: 'هذا الأسبوع',
  alltime: 'الإجمالي',
  loading: 'جار التحميل...',
  noScores: 'لا توجد نتائج بعد. كن أول بطل!',
  loadFailed: 'فشل التحميل',
  you: 'أنت',
  youConstant: 'أنت',
  language: 'اللغة',
  languageNote: 'يدعم 18 لغة بما فيها اليابانية.',
  bgm: 'موسيقى الخلفية',
  se: 'المؤثرات الصوتية',
  soundEnableAria: 'تشغيل الصوت',
  soundDisableAria: 'كتم الصوت',
  adWatch: 'شاهد الإعلان حتى النهاية',
  adCancel: 'ليس الآن',
  rankSuffix: '',
  earnedPoints: 'حقق {score} نقطة',
  helpGoalTitle: '🎯 الهدف',
  helpGoalText: 'ضع القطع على لوحة 9x9 ووسع أراضيك المتصلة. اللاعب الذي يحصل على أعلى نتيجة يفوز.',
  helpWinTitle: '🏆 شروط الفوز',
  helpWinFive: 'كون خمس قطع متتالية عمودياً أو أفقياً أو قطرياً للفوز فوراً.',
  helpWinScore: 'إذا امتلأت اللوحة، يفوز صاحب النتيجة الأعلى. لا يوجد تعادل.',
  helpScoreTitle: '💯 احتساب النقاط',
  helpLineBonus: 'مكافأة الخط: احصل على نقاط عند تكوين خطوط من 3 و4 و5 قطع.',
  helpClusterBonus: 'مكافأة الأرض: تزيد النقاط كلما كبرت مجموعات قطعك المتصلة.',
  helpKomi: 'كومي: يحصل اللاعب الثاني على مكافأة +10% من النقاط لضمان التكافؤ.',
  helpControlsTitle: '🖱️ التحكم',
  helpControlsText: 'عندما يحين دورك، اضغط على خانة فارغة لوضع قطعة.',
  helpTipsTitle: '💡 نصائح',
  helpTipHell: 'جرب مستوى HELL عندما تريد أصعب تحدٍ.',
  helpTipCluster: 'لا تكتفِ بمحاولة تكوين خمسة متتالية، فالمجموعات المتصلة الكبيرة تزيد نتيجتك أيضاً.',
  resultWinFive: '🎉 خمسة متتالية! لقد فزت!',
  resultWinScore: '🎉 فوز بالنقاط! لقد فزت!',
  resultLoseFive: '😿 كون المنافس خمسة متتالية!',
  resultLoseScore: '😿 خسارة بالنقاط. حاول مرة أخرى!',
  resultDraw: '🤝 تعادل',
  newHighscore: '🏆 نتيجة قياسية جديدة!',
  scoreNone: 'لا توجد نتيجة',
  clusterBonus: 'مكافأة الأرض',
  retry: 'العب مرة أخرى',
  titleBack: 'العنوان',
  scoreHintPlaceStone: 'ضع قطعة',
  best: 'الأفضل',
  clusterUnit: 'مجموعة',
  lineCount: '{len} متتالية x{count}',
  turnCount: 'نقلة {count} · {difficulty}',
  boardPlayerPiece: 'قطعتك',
  boardCpuPiece: 'قطعة المنافس',
  boardPlayerAlt: 'أنت',
  boardCpuAlt: 'المنافس',
  boardCellPosition: 'الصف {row}، العمود {col}',
  boardPlaceable: 'يمكن الوضع هنا',
  boardEmpty: 'خانة فارغة',
  boardFlower: 'تحتوي على زهرة',
  firstPlayerAlt: 'اللاعب الأول',
  playerFirst: 'ستبدأ أنت أولاً!',
  playerSecond: 'ستلعب ثانياً (بمكافأة كومي +{bonus}%)',
  cpuFirst: 'سيبدأ المنافس أولاً!',
  finalePlayerWin: 'لقد فزت!',
  finaleCpuWin: 'فاز المنافس!',
  finaleFive: 'خمسة متتالية!',
  finaleTerritory: 'معركة الأراضي!',
  winnerAlt: 'الفائز',
  loadingBoot: 'جاري البدء...',
  loadingConnect: 'جاري الاتصال...',
  loadingProfile: 'جاري تحميل الملف الشخصي...',
  loadingAssets: 'جاري تحميل الموارد...',
  loadingReady: 'جاهز',
  reauthRequiredTitle: 'يجب تسجيل الدخول',
  startupFailedTitle: 'فشل البدء',
  reauthButton: 'سجل الدخول مجدداً',
  reloadButton: 'إعادة تحميل',
  lineReloginButton: 'تسجيل دخول LINE',
  reauthReason: 'انتهت صلاحية تسجيل الدخول. يرجى تسجيل الدخول مجدداً.',
  errorReauth: 'انتهت صلاحية تسجيل الدخول. يرجى تسجيل الدخول مجدداً.',
  errorForbidden: 'ليس لديك صلاحية لاستخدام هذه اللعبة.',
  errorNotFound: 'لم يتم العثور على بيانات اللعبة.',
  errorRateLimited: 'الشبكة مزدحمة. يرجى الانتظار والمحاولة مرة أخرى.',
  errorServer: 'تعذر الاتصال بالخادم. يرجى الانتظار وإعادة التحميل.',
  errorCommunication: 'حدث خطأ في الاتصال. يرجى إعادة التحميل.',
  errorNetwork: 'تعذر الاتصال بالشبكة. تحقق من اتصالك وأعد التحميل.',
  errorStartup: 'فشل البدء. يرجى إعادة التحميل.',
  settingsTabGeneral: 'الإعدادات',
  settingsTabAccount: 'الحساب',
  settingsTabInfo: 'معلومات',
  account: 'الحساب',
  linked: 'مرتبط',
  guest: 'ضيف',
  loggedInWith: 'مسجل الدخول عبر {provider}',
  loggedIn: 'مسجل الدخول',
  playingAsGuest: 'أنت تلعب حالياً كضيف.',
  appleLoginBusy: 'جاري تسجيل الدخول عبر Apple...',
  appleLogin: 'سجل الدخول عبر Apple',
  googleLoginBusy: 'جاري تسجيل الدخول عبر Google...',
  googleLogin: 'سجل الدخول عبر Google',
  logoutBusy: 'جاري تسجيل الخروج...',
  logout: 'تسجيل الخروج',
  logoutSuccess: 'تم تسجيل الخروج',
  logoutFailed: 'فشل تسجيل الخروج',
  appInfo: 'معلومات التطبيق',
  appName: 'اسم التطبيق',
  version: 'الإصدار',
  legalInfo: 'معلومات قانونية',
  terms: 'شروط الاستخدام',
  privacy: 'سياسة الخصوصية',
  operator: 'المشغل',
  contact: 'اتصل بنا',
  copyTap: 'اضغط للنسخ',
  idCopied: 'تم نسخ المعرف',
  copyFailed: 'فشل النسخ',
  other: 'أخرى',
  reportAd: 'إبلاغ عن إعلان غير لائق',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'تعديل الملف الشخصي',
  displayName: 'الاسم المستعار',
  displayNamePlaceholder: 'أدخل الاسم',
  chooseIcon: 'اختر أيقونة',
  iconLoadFailed: 'فشل تحميل الأيقونات.',
  saveFailed: 'فشل الحفظ. يرجى المحاولة مرة أخرى.',
  noIcons: 'لا توجد أيقونات متاحة.',
  save: 'حفظ',
  saving: 'جاري الحفظ...',
  staminaAria: 'الطاقة {stamina} / {max}',
  nextRecovery: 'الاسترداد التالي خلال {time}',
  adPlaying: 'جاري عرض الإعلان...',
  recoverFullAd: 'شاهد إعلانًا لاستعادة الطاقة بالكامل',
  dailyBonusAria: 'شاهد الإعلان حتى النهاية للحصول على +5 طاقة',
  dailyBonusAd: 'شاهد إعلانًا للحصول على +5 طاقة',
  legalLastUpdated: 'آخر تحديث: {date}',
  privacyTitle: 'سياسة الخصوصية',
  termsTitle: 'شروط الاستخدام',
  adPlayingAria: 'جاري تشغيل الإعلان',
  adBadge: '▶ إعلان',
  adRemaining: 'متبقي {seconds} ثانية',
  adDevHint: 'إعلان تجريبي. في النسخة النهائية، سيتم تشغيل فيديو AdMob.',
  adRewardRequirement: 'شاهد الإعلان حتى النهاية للحصول على هذه المكافأة.',
  adRewardStaminaDetail: 'المكافأة: استعادة الطاقة إلى الحد الأقصى',
  adRewardDailyBonusDetail: 'المكافأة: +{amount} طاقة كمكافأة يومية',
  adRewardIncompleteNote: 'إذا أغلقت قبل النهاية، فلن تحصل على المكافأة.',
  adSkipAria: 'تخطي الإعلان',
  adSkip: 'تخطي ✕',
  adSkipAfter: 'تخطي خلال {seconds} ثانية',
  offlineMessage: 'تعذر الاتصال بالخادم. قد تكون بعض الميزات غير متوفرة.',
  reconnecting: 'جاري إعادة الاتصال...',
  reconnect: 'إعادة الاتصال',
  signInTitle: 'تسجيل الدخول',
  signInBusy: 'جاري تسجيل الدخول...',
  signInCancelNote: 'إذا ألغيت تسجيل الدخول، يمكنك الاستمرار كضيف (بعض الميزات ستكون محدودة).',
  processing: 'جاري المعالجة...',
  recoverConfirmTitle: 'تأكيد استبدال البيانات',
  recoverConfirmMessage: 'توجد بيانات حالية مرتبطة بتسجيل الدخول هذا. الاستمرار سيؤدي لاستبدال بيانات الضيف على هذا الجهاز. هل تريد الاستمرار؟',
  recoverConfirmContinue: 'استعادة',
  recoverConfirmCancel: 'إلغاء',
  unlinkConfirmTitle: 'إلغاء ربط الحساب',
  unlinkConfirmMessage: 'إذا ألغيت ربط هذا المزود، سيعود هذا الجهاز إلى وضع الضيف. ستبقى بياناتك في Hub متاحة إذا سجلت الدخول مجدداً بنفس المزود على جهاز آخر.',
  unlinkConfirmContinue: 'إلغاء الربط',
  unlinkConfirmCancel: 'إلغاء',
  deleteConfirmTitle: 'تأكيد حذف الحساب',
  deleteConfirmMessage: 'حذف حسابك سيؤدي لإزالة أفضل النتائج، وبيانات تسجيل الدخول، والحسابات المرتبطة، والدعوات.\nلا يمكن التراجع عن هذا الإجراء. هل تريد الحذف حقاً؟',
  deleteConfirmContinue: 'حذف الحساب',
  deleteConfirmCancel: 'إلغاء',
  adNekoTitle: 'قط الإعلانات',
  matchmakingRemaining: 'متبقي {seconds} ثانية',
  matchmakingTimeoutMessage: 'لم يتم العثور على منافس في الوقت المحدد. يرجى المحاولة مرة أخرى.',
  difficultyEasyName: 'سهل',
  difficultyEasyDescription: 'المنافس يبدو مشتتاً قليلاً',
  difficultyNormalName: 'عادي',
  difficultyNormalDescription: 'المنافس يرتكب بعض الأخطاء أحياناً',
  difficultyHardName: 'صعب',
  difficultyHardDescription: 'المنافس لديه رؤية واسعة للوحة',
  difficultyHellName: 'جحيم',
  difficultyHellDescription: 'المنافس قوي جداً ويقرأ التحركات مسبقاً',
}
